import React, { lazy, Suspense } from "react";
import { Spinner } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";
//import through lazy loading
const Marque = lazy(() => import("../components/Marque/Index"));
const Header = lazy(() => import("../components/Header/index"));
const Footer = lazy(() => import("../components/Footer/Footer"));
const BottomFooter = lazy(() =>
  import("../components/BottomFooter/BottomFooter")
);
const componentMap = {
  Home: lazy(() => import("../pages/Home/Home")),
  AboutUs: lazy(() => import("../pages/AboutUs/index")),
  Loginwithemail_V2: lazy(() =>
    import("../pages/LoginWithEmailV2/LoginWithEmailV2")
  ),
  OrganisationalStructure: lazy(() =>
    import("../pages/OrganisationalStructure/index")
  ),
  MissionVision: lazy(() => import("../pages/MissionVision/MissionVision")),
  Infrastructure: lazy(() => import("../pages/Infrastructure/Infrastructure")),
  Etender: lazy(() => import("../pages/E-Tender/Etender")),
  WebsiteNotification: lazy(() =>
    import("../pages/WebsiteNotification/WebsiteNotification")
  ),
  Calender: lazy(() => import("../pages/Calender/index")),
  Athletes: lazy(() => import("../pages/Athletes/Athletes")),
  LatestNews: lazy(() => import("../pages/LatestNews/LatestNews")),
  LatestNewsSinglePage: lazy(() =>
    import("../pages/LatestNews/LatestNewsSinglePage.js")
  ),
  LatestVideos: lazy(() => import("../pages/LatestVideos/LatestVideos")),
  NewsDetails: lazy(() => import("../pages/NewsDetails/NewsDetails")),
  Contactus: lazy(() => import("../pages/ContactUs/ContactUs")),
  PhotoGallery: lazy(() => import("../pages/PhotoGallery/PhotoGallery")),
  AthletesProfile: lazy(() =>
    import("../pages/AthletesProfile/AthletesProfile")
  ),
  RightToInfo: lazy(() => import("../pages/RightToInfo/RightToInfo")),
  Scholarship: lazy(() => import("../pages/Scholarship/Scholarship")),
  HeadtoHead: lazy(() => import("../pages/HeadtoHead/HeadtoHead")),
  ForgetPassword: lazy(() => import("../pages/ForgetPassword/ForgetPassword")),
  LoginwithOTP_V2: lazy(() => import("../pages/LoginWithOTPV2/LoginWithOTPV2")),
  Registration: lazy(() => import("../pages/Registration")),
  Scheme: lazy(() => import("../pages/Scheme")),
  Schemes: lazy(() => import("../pages/Schemes/Index.jsx")),
  SchemeDetails: lazy(() => import("../pages/SchemeDetails/Index.jsx")),
  SlotBooking: lazy(() => import("../pages/SlotBooking/Index.jsx")),
  VenueDetails: lazy(() => import("../pages/SlotBooking/VenueDetails.jsx")),
  TicketDetails: lazy(() => import("../pages/SlotBooking/TicketDetails.jsx")),
  Payment: lazy(() => import("../pages/SlotBooking/Payment.jsx")),
  MyBooking: lazy(() => import("../pages/SlotBooking/Booking/MyBooking.jsx")),
  VenueBookingDetails: lazy(() => import("../pages/SlotBooking/VenueBookingDetails.jsx")),
  ComingSoon: lazy(() => import("../components/ComingSoonPage/ComingSoon")),
  achiever: lazy(() => import("../pages/AchiverCard/AchiverCard.jsx")),
  InsitutionInitialCard: lazy(() =>
    import("../pages/InsitutionInitialCard/InsitutionInitialCard")
  ),
  InstitutionRegistration: lazy(() =>
    import("../pages/InstitutionRegistration")
  ),
  InstitutionStatusCard: lazy(() =>
    import("../pages/InsitutionRegisterStatus/RegistrationStatusCard")
  ),
  Error404: lazy(() => import("../pages/Error404/Error404.jsx")),
};

//Routes
const authRoutes = [{ path: "", element: "" }];

const publicRoutes = [
  { path: "/", element: "Home" },
  { path: "/aboutUs", element: "AboutUs" },
  { path: "/login_email", element: "Loginwithemail_V2" },
  { path: "/organisational_structure", element: "OrganisationalStructure" },
  { path: "/tender", element: "Etender", props: { id: "1" } },
  { path: "/login_otp", element: "LoginwithOTP_V2" },
  { path: "/forget_password", element: "ForgetPassword" },
  { path: "/otp-verification", element: "OTP_Verification" },
  { path: "/create-new-password", element: "CreateNewPassword" },
  { path: "/registration", element: "Registration" },
  { path: "/institution-registration", element: "InstitutionRegistration" },
  {
    path: "/institution-registration-profile",
    element: "InsitutionInitialCard",
  },
  { path: "/final-status", element: "InstitutionStatusCard" },
  { path: "/infrastructure", element: "Infrastructure" },
  { path: "/scholarship", element: "Scholarship" },
  { path: "/policie", element: "Etender", props: { id: "7" } },
  { path: "/govt-circular", element: "Etender", props: { id: "8" } },
  { path: "/contact-us", element: "Contactus" },
  { path: "/calendar", element: "Calender" },
  { path: "/athletes", element: "Athletes" },
  { path: "/athletes_profile", element: "AthletesProfile" },
  { path: "/head_to_head", element: "HeadtoHead" },
  { path: "/latest-news", element: "LatestNews" },
  { path: "/latest-news/:id", element: "LatestNewsSinglePage" },
  { path: "/news-details", element: "NewsDetails" },
  { path: "/latest-videos", element: "LatestVideos" },
  { path: "/photoGallery", element: "PhotoGallery" },
  { path: "/right-to-information", element: "RightToInfo" },
  { path: "/mission_vision", element: "MissionVision" },
  { path: "/website-notification", element: "WebsiteNotification" },
  { path: "/scheme", element: "Scheme" },
  { path: "/achievers", element: "achiever" },
  { path: "/schemes", element: "Schemes" },
  { path: "/scheme-details", element: "SchemeDetails" },
  { path: "/venue-list", element: "SlotBooking" },
  { path: "/venue-details", element: "VenueDetails" },
  { path: "/venue-slot-booking-status", element: "TicketDetails" },
  { path: "/venue-slot-booking-details", element: "Payment" },
  { path: "/venue-my-booking", element: "MyBooking" },
  { path: "/venue-booking-details", element: "VenueBookingDetails" },
  { path: "/comingsoon", element: "ComingSoon" },
  { path: "/*", element: "Error404" },
];


const hideComponentsOnRoutes = [
  "/login_otp",
  "/login_email",
  "/registration",
  "/register_as_support_staff",
  "/register_as_athlete",
  "/register_as_other",
  "/forget-password",
  "/otp-verification",
  "/individual",
  "/create-new-password",
  "/final-submit_individual_registration",
  "/auth_registration",
  "/register_as",
  "/final-status",
];
const hideFooterRoutes = [...hideComponentsOnRoutes, "/infrastructure"];

export default function MainRoutesComp() {
  const location = useLocation();
  const currentPath = location.pathname;
  const hideHeaderAndMarque = hideComponentsOnRoutes.includes(
    location.pathname
  );
  const hideFooter = hideFooterRoutes.includes(currentPath);
  return (
    <>
      <div>
        {!hideHeaderAndMarque && (
          <div>
           
            <Marque />
            <Header />
          </div>
        )}
      </div>
      <Suspense
        fallback={
          <>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <Spinner animation="border" role="status" variant="primary">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </>
        }
      >
        <Routes>
          {publicRoutes.map((route, index) => {
            const Component = componentMap[route.element];
            return Component ? (
              <Route
                key={index}
                path={route.path}
                element={<Component {...(route.props || {})} />}
              />
            ) : null;
          })}
        </Routes>
      </Suspense>

      {!hideFooter && (
        <>
          <Footer />
          <BottomFooter />
        </>
      )}
    </>
  );
}
